import rq from '@/request'

const get = () => rq.get(`master-data/ng-words`)

export default {
  get
}



// WEBPACK FOOTER //
// ./src/api/ng-word.js